// extracted by mini-css-extract-plugin
export default {"moreButton":"_3Ll_E","openButton":"_13thR","arrow":"_1zhxH","arrowUp":"FIT4H","actionText":"_3P7jh","preLabel":"_3F98C"};